export default {
  title: 'スキャンテンプレートを選択',
  empty: 'テンプレートデータがありません',
  searchPlaceholder: 'テンプレート名で検索',
};
